import React from 'react';
import styles from './GroupCardSkeleton.module.scss';

export default function GroupCardSkeleton() {
    return (
        <div className={styles.card}>
            <div className={styles.logo} />
            <div className={styles.separator} />
            <div className={styles.name} />
        </div>
    );
}
